import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import systemContext from "../../AppState/SystemConfig/appContext";
import { useEffect, useState } from "react";
import TokenValidateDialog from "./tokenValidateDialog.jsx";
import { Box } from "@mui/material";

function UserAccess() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { AppManager } = useContext(systemContext);
  const [validated, setValidated] = useState(false);
  const [isloading, setIsloading] = useState(false);


  useEffect(() => {
    if (search) {
      const queryParams = new URLSearchParams(search);
      setIsloading(true);
      // Obtener el valor del parámetro "token" de los query params
      const token = queryParams.get("auth");

      //   const authUser= {
      //       User: "PAC1",
      //       Pasword: "PAC1"
      //     };

      try {
        const { User, Password } = AppManager.decriptData(token);
        AppManager.clickLogin(0, User, Password);
      } catch (e) {
        setValidated(false);
        setIsloading(false);
      }
    }

    return () => {
      // cleanup
      setValidated(false);
    };
  }, [AppManager, search, navigate]);

  return (
    <Box>
      <TokenValidateDialog validated={validated} isloading={isloading}></TokenValidateDialog>
    </Box>
  );
}

export default UserAccess;
